module.exports = __webpack_public_path__ + "img/coach-progress-great.be799aeb.svg";